import { Button } from "reactstrap";
import { seperator } from "../../../helperFunctions";
import { getStatusStyle } from "../../../theme";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { updateChangeBack } from "../../../redux/slices/transactionSlice";
import { showToaster } from "../../../constant";
import Loader from "../../../components/Custom/Loader";
import { isChargebackWithinHour } from "../Transaction/mock";

const DepositChargeBackTableDetail = (props) => {
  const { item, onGet } = props;
  const { bgClassName } = getStatusStyle(item?.paymentSts);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const dispatch = useDispatch();

  const handleUpdateChangeBack = async (txnId) => {
    try {
      if (!isChargebackWithinHour(item?.chargebackAtIst)) {
        showToaster(
          "Chargeback can only be cancelled within 60 minutes of initiation.",
          "Error"
        );
        return;
      }
      const payload = {
        txnId,
        isChargeBack: 0,
      };
      setIsLoading(true);
      const res = await dispatch(updateChangeBack({ ...payload })).unwrap();
      if (res?.status) {
        setIsUpdate(true);
        onGet?.();
      }
      showToaster(res?.message);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex tabmain"></div>
      <div className="mainbox">
        <div className="d-flex justify-content-between">
          <div className="box-style">
            <h5>
              <span>Customer Details</span>
            </h5>
            <div className="other-sec">
              <p>
                <b> Name : </b> {item?.custName}
              </p>
              <p>
                <b> Email : </b> {item?.custEmail}
              </p>
              <p>
                <b> Mobile : </b> {item?.custMobile}
              </p>
              <p>
                <b> Ip : </b> {item?.custIp}
              </p>
              <p>
                <b> Device : </b> {item?.device}
              </p>
              <p>
                <b> Refer Url : </b>{" "}
                <span
                  style={{ overflowWrap: "anywhere", whiteSpace: "normal" }}
                >
                  {item?.refererUrl}
                </span>
              </p>
              <p>
                <b> Payment Data : </b> {item?.paymentData}
              </p>
              <p>
                <b> Customer Level : </b>{" "}
                <span className="themecolor">{item?.custLevel}</span>
              </p>
            </div>
          </div>
          <div className="box-style">
            <h5>
              <span>Order Details</span>
            </h5>
            <div className="other-sec">
              <p>
                <b>MMPID :</b> {item?.bankMerchantPayId}
              </p>
              <p>
                <b>Temp UTR :</b> {item?.tempBankUtr}
              </p>
              <p>
                <b>Browser ID : </b>
                {item?.browserId || "-"}
              </p>
              <p>
                <b>Customer City :</b> {item?.custCity}
              </p>
              <p>
                <b>Udf5 :</b> {item?.udf5 || "-"}
              </p>
              <p>
                <b>isUsed :</b> {item?.isUsed || "-"}
              </p>
            </div>
          </div>
          <div className="box-style">
            <h5>
              <span>Client Details</span>
            </h5>
            <div className="other-sec">
              <p>
                <b>Name :</b> {item?.merchantDatas?.merchantName}
              </p>
              <p>
                <b>Asso.Fee :</b> {seperator(item?.associateFees)}
              </p>
              <p>
                <b>PG Ref:</b> {item?.pgRefId}
              </p>
            </div>
          </div>
          <div className="box-style">
            <h5>
              <span> PG Details</span>
            </h5>
            <div className="other-sec">
              <p>
                <b>Account : </b> {item?.acNumber || "-"}
              </p>
              <p>
                <b>UPI :</b> {item?.upiId || "-"}
              </p>
              <p>
                <b>Bank :</b> {item?.bankName || "-"}
              </p>
              <p>
                <b>IFSC : </b> {item?.ifscCode || "-"}
              </p>
              <p>
                <b>UPI NAME : </b> {item?.pgBankUpiName || "-"}
              </p>
              <p>
                <b>UPI ID : </b> {item?.pgBankUpiId || "-"}
              </p>
              <p>
                <b>BANK ID : </b> {item?.bankId || "-"}
              </p>
            </div>
          </div>
          <div className="box-style d-flex flex-column justify-content-between">
            <div>
              <h5>
                <span> Player Details</span>
              </h5>
              <div className="other-sec">
                <p>
                  <b>Deposit Amount : </b> {item?.playerDepositAmt || "-"}
                </p>
                <p>
                  <b>Deposit Count :</b> {item?.playerDepositCount || "-"}
                </p>
                <p>
                  <b>Register Date :</b> {item?.playerRegisterDate || "-"}
                </p>
                <p>
                  <b> Reason : </b> {item?.Purpose}
                </p>
              </div>
            </div>
            <div>
              {item?.processBy ? (
                <div className="bgDiv">Update By : {item?.processBy}</div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="amount-sec">
          <div className="amount-sub">
            <div>
              <p>Total Amount</p>
              <h4>{`${seperator(+item?.paymentAmt)}`}</h4>
            </div>
            <div>
              <p>Order ID</p>
              <h6> {item?.merchantOrderId}</h6>
            </div>
            <div>
              <p>UTR</p>
              <h6> {item?.utr}</h6>
            </div>
            <div>
              <p>Status</p>
              <span className={`${bgClassName}`}>{item?.paymentSts}</span>
            </div>
            {item?.chargebackAtIst &&
              isChargebackWithinHour(item?.chargebackAtIst) &&
              !!item?.isChargeBack ? (
              <div className="d-flex gap-1">
                <Button
                  className="tablebtn btn-smallsize"
                  onClick={() => handleUpdateChangeBack(item?.txnId)}
                  disabled={isUpdate}
                >
                  {isLoading ? <Loader size={20} /> : "Cancel Chargeback"}
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default DepositChargeBackTableDetail;
